import { AxiosResponse } from "axios";
import { axiosInstance } from "./common";

export enum UserRole {
    CANSO_ADMIN = "CANSO_ADMIN",
    ADMIN = "ADMIN",
    INVESTIGATOR = "INVESTIGATOR",
    VIEWER = "VIEWER",
    COLLABORATOR = "COLLABORATOR",
    CASE_INITIATOR = "CASE_INITIATOR",
    SUPERVISING_AUTH_L1 = "SUPERVISING_AUTH_L1",
    SUPERVISING_AUTH_L2 = "SUPERVISING_AUTH_L2",
    AUDITOR = "AUDITOR",
    BUSINESS_ADMIN = "BUSINESS_ADMIN",
    PLATFORM_ADMIN = "PLATFORM_ADMIN"
}

export interface User {
  user_id: string;
  user_name: string;
  email_id: string;
  department: string;
  description: string;
  role: UserRole;
  tenant_id: string;
  tenant_name: string;
}

interface UserParams {
  role?: UserRole[];
  user_id?: string[];
  email_id?: string[];
}

interface UsersResponse {
  users: User[];
}

export enum UserGroupName {
  CONVENERS = "CONVENERS",
  COMMITTEE_MEMBERS = "COMMITTEE_MEMBERS",
  DEALING_OFFICERS = "DEALING_OFFICERS",
  IO_APPOINTING_AUTHORITIES = "IO_APPOINTING_AUTHORITIES",
  FRMD_ADMINS = "FRMD_ADMINS",
  FORWARDING_AUTHORITIES = "FORWARDING_AUTHORITIES"
}

const UsersAPI = {
  get_users_with_roles: async (roles: UserRole[]) => {
    try {
      const params: UserParams = { role: roles };
      const response: AxiosResponse<UsersResponse> = await axiosInstance.get(
        "/v1/users",
        { 
          params: params,
          paramsSerializer: {
            indexes: null,
          }, 
        }
      );
      return response.data.users;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  get_users_with_user_ids: async (user_ids: string[]) => {
    try {
      const params: UserParams = { user_id: user_ids };
      const response: AxiosResponse<UsersResponse> = await axiosInstance.get(
        "/v1/users",
        { 
          params: params,
          paramsSerializer: {
            indexes: null,
          }, 
        }
      );
      return response.data.users;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  get_users_with_email_ids: async (email_ids: string[]) => {
    try {
      const params: UserParams = { email_id: email_ids };
      const response: AxiosResponse<UsersResponse> = await axiosInstance.get(
        "/v1/users",
        { 
          params: params,
          paramsSerializer: {
            indexes: null,
          }, 
        }
      );
      return response.data.users;
    } catch (error) {
      console.error(error);
      return [];
    }
  },

  getUsersByGroup: async (groupName: UserGroupName) => {
    const response: AxiosResponse<UsersResponse> =
      await axiosInstance.get(
        `/v1/user-groups/${groupName}/users`
      );

    return response.data.users;
  },

};

export default UsersAPI;
